import React, { useState } from 'react';
import StatGraph from '../components/StatGraph';
import Timer from '../components/Timer';
import MainMenu from '../components/MainMenu';
import PlayerInput from '../components/PlayerInput';

const TestPage = () => {
    
    return (
        <div>
            {/* <StatGraph/>
            <Timer expiryTimestamp={30} /> */}
            <MainMenu />
        </div>
    )
};

export default TestPage;
